module.exports = __webpack_public_path__ + "img/img01.b33e33a1.svg";